/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['svg-icon{display:inline-block;width:24px;height:24px;vertical-align:inherit}svg-icon>svg{display:block;fill:currentColor;width:inherit;height:inherit}svg-icon.size-18{width:18px;height:18px}svg-icon.size-20{width:20px;height:20px}svg-icon.size-22{width:22px;height:22px}svg-icon.align-middle{vertical-align:middle}svg-icon.block{display:block}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvc3ZnLWljb24vc3ZnLWljb24uY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3N2Zy1pY29uL3N2Zy1pY29uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/svg-icon/svg-icon.component.scss.ngstyle.ts